module.exports = __webpack_public_path__ + "img/notes.89b06958.jpg";